import React from 'react';
import './Button.css';

export default function Button({ variant = 'ghost', size = 'md', children, className = '', ...props }) {
  return (
    <button
      className={`btn btn-${variant} btn-${size} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
